import { HttpMethod } from './enums';
import { HttpRequest } from './http-request';
import { HttpRequestOptions, HttpResponse } from './models';

export type OutgoingHttpHeaders = {
    [key: string]: string[] | string
}

export class HttpClient {

    constructor() {
    }

    beacon(url: string, body: string, query: { [key: string]: string }): boolean | Promise<HttpResponse> {
        const uri: URL = new URL(url);
        for (const k in query) {
            if (query.hasOwnProperty(k)) {
                uri.searchParams.append(k, query[k]);
            }
        }
        if (!navigator.sendBeacon) {
            return this.post(uri.toString(), body, {}, {});
        }
        return navigator.sendBeacon(uri.toString(), body);
    }

    async post(url: string, body: string, headers: OutgoingHttpHeaders = {}, options: HttpRequestOptions = null): Promise<HttpResponse> {
        return this.request(HttpMethod.Post, url, headers, options).sendAsync(body);
    }

    async put(url: string, body: string, headers: OutgoingHttpHeaders = {}, options: HttpRequestOptions = null): Promise<HttpResponse> {
        return this.request(HttpMethod.Put, url, headers, options).sendAsync(body);
    }

    async patch(url: string, body: string, headers: OutgoingHttpHeaders, options: HttpRequestOptions = null): Promise<HttpResponse> {
        return this.request(HttpMethod.Patch, url, headers, options).sendAsync(body);
    }

    async get(url: string, headers: OutgoingHttpHeaders = {}, options: HttpRequestOptions = null): Promise<HttpResponse> {
        return this.request(HttpMethod.Get, url, headers, options).sendAsync();
    }

    async head(url: string, headers: OutgoingHttpHeaders = {}, options: HttpRequestOptions = null): Promise<HttpResponse> {
        return this.request(HttpMethod.Head, url, headers, options).sendAsync();
    }

    request(method: HttpMethod, url: string, headers: OutgoingHttpHeaders = {}, options: HttpRequestOptions = null): HttpRequest {
        const request: HttpRequest = new HttpRequest(method, url, options);
        for (let header in headers) {
            if (headers.hasOwnProperty(header)) {
                request.setHeader(header, headers[header]);
            }
        }
        return request;
    }

}
